import { Card, CardContent, Stack, Typography } from '@mui/material'
import { FunctionComponent, ReactNode } from 'react'
import { Link } from 'react-router-dom'

export const ThirdPartyConnectionsCard: FunctionComponent<{
  title: string,
  // A provider logo. Tiles without a logo asset pass `icon` instead, rendered in the same
  // reserved 100px box so every tile keeps the same height.
  image?: string,
  // Width of `image` in px. Square and stacked logos read well at the default 100px; a wide
  // lockup with small text (Business Central) needs more to match the other tiles.
  imageWidth?: number,
  icon?: ReactNode,
  description: string, link: string, comingSoon?: boolean,
}> =
  ({ title, image, imageWidth, icon, description, link, comingSoon = false }) => {
    const imageStyle = imageWidth ? { width: imageWidth, maxWidth: '100%' } : undefined;
    const mark = image
      ? <img src={image} alt={title} width={title === 'QuickBooks' ? '75px' : '100rem'} style={imageStyle} />
      : icon;
    return (
      <Card sx={{
        height: '100%', boxShadow: 'none', borderWidth: '1px', borderStyle: 'solid', borderColor: 'lightGrey.main', borderRadius: '10px', pt: 1, pr: 1, pl: 1,
        backgroundColor: comingSoon ? 'lightGrey.light' : 'fff'}}>
        {!comingSoon &&
          <Link to={link} style={{ textDecoration: 'none' }}>
            <CardContent sx={{ p: 0 }}>
              <Stack justifyContent='center' alignItems='center'>
                <Stack sx={{ height: '100px', justifyContent: 'center', alignItems: 'center' }}>
                  {mark}
                </Stack>
                <Stack sx={{ pt: 2, pl: 2, pr: 2 }}>
                  <Typography variant='subtitle1' sx={{ fontWeight: 600, color: 'text.primary', pb: 1 }}>
                    {title}
                  </Typography>
                  {description && <Typography variant='body2' sx={{ color: 'text.secondary' }}>
                    {description}
                  </Typography>}
                </Stack>
              </Stack>
            </CardContent>
          </Link>
        }
        {comingSoon &&
          <CardContent sx={{ p: 0}}>
            <Stack justifyContent='center' alignItems='center'>
              <Stack sx={{ height: '100px', justifyContent: 'center', alignItems: 'center' }}>
                {image ? <img src={image} alt={title} width='100rem' style={imageStyle} /> : icon}
              </Stack>
              <Stack sx={{ pt: 2, pl: 2, pr: 2 }}>
                <Typography variant='subtitle1' sx={{ fontWeight: 600, color: 'text.primary', pb: 1 }}>
                  {title}
                </Typography>
                {description && <Typography variant='body2' sx={{ color: 'text.secondary' }}>
                  {description}
                </Typography>}
                <Typography variant='subtitle1' sx={{ color: 'text.secondary', textAlign: 'center', mt: 3 }}>
                 COMING SOON
                </Typography>
              </Stack>
            </Stack>
          </CardContent>
        }
      </Card>
    )
  }